import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';
import grey from '@material-ui/core/colors/grey';

import {
  Filter,
  FilterButton,
  FilterDivider,
  FilterItem,
} from 'components/core/Filter';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import { startAddBid } from '../../../store/actions/bids';
import { startAddProject } from '../../../store/actions/projects';
import { startEditAdmin } from '../../../store/actions/admin';
import { startEditProjectListFilter } from '../../../store/actions/filters';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    marginLeft: theme.spacing.unit*4,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  }
});

const JobFilters = (props) => {
  const {
    classes,
    help,
    projectListFilter,
    startAddBid,
    startAddProject,
    startEditAdmin,
    startEditProjectListFilter,
  } = props;

  return(
    <div className={classes.root}>
      <Filter>
        <FilterItem>
          <FilterButton
            selected={projectListFilter.type === "all"}
            onClick={() => startEditProjectListFilter({type: "all"})}>
            All
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <Tooltip type={TooltipTypes.job.FILTERS} placement="bottom">
          <div />
        </Tooltip>
        <FilterItem caption="Filter">
          <FilterButton
            selected={projectListFilter.type === "new"}
            onClick={() => startEditProjectListFilter({type: "new"})}>
            New
          </FilterButton>
          <FilterButton
            selected={projectListFilter.type === "active"}
            onClick={() => startEditProjectListFilter({type: "active"})}>
            Active
          </FilterButton>
          <FilterButton
            selected={projectListFilter.type === "closed"}
            onClick={() => startEditProjectListFilter({type: "closed"})}>
            Closed
          </FilterButton>
          <FilterButton
            selected={projectListFilter.type === "held"}
            onClick={() => startEditProjectListFilter({type: "held"})}>
            Held
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Sort">
          <FilterButton
            selected={projectListFilter.orderBy === "date"}
            onClick={() => {
              let direction = "asc";
              if (projectListFilter.orderBy === "date") {
                direction = projectListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditProjectListFilter({orderBy: "date", direction: direction})
            }}>
            Date
          </FilterButton>
          <FilterButton
            selected={projectListFilter.orderBy === "client"}
            onClick={() => {
              let direction = "asc";
              if (projectListFilter.orderBy === "client") {
                direction = projectListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditProjectListFilter({orderBy: "client", direction: direction})
            }}>
            Client
          </FilterButton>
          <FilterButton
            selected={projectListFilter.orderBy === "job"}
            onClick={() => {
              let direction = "asc";
              if (projectListFilter.orderBy === "job") {
                direction = projectListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditProjectListFilter({orderBy: "job", direction: direction})
            }}>
            Job
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem hideCaption>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={projectListFilter.showArchived}
                onChange={() => {
                  startEditProjectListFilter({showArchived: !projectListFilter.showArchived})
                }}
              />
            }
            label="SHOW ARCHIVED"
          />
        </FilterItem>
      </Filter>
      <Tooltip type={TooltipTypes.job.ADD} placement="left">
        <Button
          className={classNames(classes.addButton, help.isCurrentStep(TooltipTypes.job.ADD) && classes.elevate)}
          variant="fab"
          aria-label="add"
          onClick={() => {
            startAddProject({
              startDate: (new Date()).getTime(),
            }).then((project) => {
              helpDispatch(TooltipTypes.job.ADD);
              startEditAdmin({ project: project});
            });
          }}>
          <AddIcon />
        </Button>
      </Tooltip>
    </div>
  );
};

JobFilters.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
  const projectListFilter = state.filters.projectList ? state.filters.projectList : {};

  return({
    projectListFilter,
    help: state.help,
  });
};

const mapDispatchToProps = {
  startAddBid,
  startAddProject,
  startEditAdmin,
  startEditProjectListFilter,
}
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobFilters);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/JobFilters.jsx